import { htmlIdGenerator } from "@inscopix/ideas-eui";
import { addToast } from "../components/GlobalToastList/GlobalToastList";

export function addUtilityToastFailure(message: string) {
  addToast({
    id: htmlIdGenerator()(),
    title: "Failed",
    color: "danger",
    text: <p>{message}</p>,
  });
}
